import { Injection } from "@faizaanceg/syringe";
import { BrandConfigurationOperations } from "common/brand-configuration";
import { SimpleApi } from "common/simple-api";
import { ClientDetails, SiteDetails, SiteUrlProvider } from "../../webpro";

export class SiteDetailsManager {
  private client: ClientDetails = null;
  private clientPromise: Promise<ClientDetails> = null;
  private backend: string = null;
  private site: Partial<SiteDetails> = null;
  private siteUrlProvider: SiteUrlProvider = null;

  constructor(
    backend: string,
    siteUrlProvider: SiteUrlProvider,
    private sessionManager: SessionManager
  ) {
    this.backend = backend;
    this.siteUrlProvider = siteUrlProvider;
  }
  static register() {
    const SiteManagerFactory: Injection<"siteManager"> = {
      name: "siteManager",
      injectFn: ({ runtime, siteUrlProvider, sessionManager }) =>
        new SiteDetailsManager(
          runtime.backend,
          siteUrlProvider,
          sessionManager
        ),
      uses: [
        { name: "runtime" },
        { name: "siteUrlProvider" },
        { name: "sessionManager" }
      ]
    };
    return SiteManagerFactory;
  }

  async clientDetails() {
    if (this.client !== null) {
      return this.client;
    }
    if (!this.clientPromise) {
      this.clientPromise = (async () => {
        const headers = new Headers({ Accept: "application/json" });
        let credentials: RequestCredentials = "include";
        const session = await this.sessionManager.create(false);
        if (session?.accessToken) {
          headers.set("Authorization", `Bearer ${session.accessToken}`);
          credentials = "omit";
        }
        const response = await fetch(`${this.backend}user/details`, {
          method: "GET",
          headers,
          credentials
        });
        if (!response.ok) {
          throw new Error(`user/details failed: ${response.status}`);
        }
        return response.json() as Promise<ClientDetails>;
      })()
        .catch(() => ({ ip: "", country: "" } as ClientDetails))
        .then(result => {
          this.client = result;
          return result;
        });
    }
    return this.clientPromise;
  }
  async details() {
    if (this.site === null) {
      let siteUrl = this.siteUrlProvider();
      const brandConfiguration =
        BrandConfigurationOperations.findByUrl(siteUrl);
      if (brandConfiguration?.siteDetails) {
        this.site = brandConfiguration.siteDetails;
      } else {
        this.site = await SimpleApi.get(
          `${this.backend}user/branded-url/details`,
          { "branded-url": siteUrl }
        ).catch(() => null);
      }
      if (this.site) {
        this.site.url = siteUrl;
      }
    }
    return this.site;
  }
}
